import {connect} from 'react-redux';
import PropTypes from 'prop-types';

const withState = connect((state) => ({
    toasts: state.toasts
}));

export const WithToasts = withState(({render, toasts}) => (
    render(toasts)
));

WithToasts.propTypes = {
    render: PropTypes.func.isRequired
};
